// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3HH8D","productName":"Table_productName__EhulQ"};